import { useEffect, useState } from "react"

const QUERY = "(prefers-reduced-motion: no-preference)"

export default function usePrefersReducedMotion() {
  // Use the same initial value on server and client to avoid hydration mismatch.
  // Server always gets true; client starts with true then updates in useEffect.
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true)
  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY)
    setPrefersReducedMotion(!mediaQueryList.matches)
    const listener = (event) => {
      setPrefersReducedMotion(!event.matches)
    }
    mediaQueryList.addListener(listener)
    return () => {
      mediaQueryList.removeListener(listener)
    }
  }, [])
  return prefersReducedMotion
}
